function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      opacity: 1,
      color: "#000000",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M 50.15625 10.8125 A 3.0003 3.0003 0 0 0 47.4375 12.3125 L 5.40625 84.46875 A 3.0003 3.0003 0 0 0 8 89 L 92 89 A 3.0003 3.0003 0 0 0 94.59375 84.46875 L 52.625 12.3125 A 3.0003 3.0003 0 0 0 50.15625 10.8125 z M 50.03125 19.8125 L 86.78125 83 L 13.21875 83 L 50.03125 19.8125 z M 50 37 C 47.238576 37 45 39.238576 45 42 L 50 65 L 55 42 C 55 39.238576 52.761424 37 50 37 z M 50 68 C 47.238575 68 45 70.2386 45 73 C 45 75.7614 47.238575 78 50 78 C 52.761425 78 55 75.7614 55 73 C 55 70.2386 52.761425 68 50 68 z ",
    transform: "translate(0,952.36218)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7bed0bf2cc604ecd84cae3d1069069d5.svg";
export { ForwardRef as ReactComponent };